import { apiClient } from '@/lib/api-client';
import type { ApiResponse } from '@/types/api';

export interface PairingTokenDto {
  id: string;
  token: string;
  url: string;
  shortCode: string;
  propertyId: string;
  propertyName?: string;
  buildingId: string;
  buildingName?: string;
  createdByUserId: string;
  createdByUserName?: string;
  expiresAt: string;
  createdAt: string;
  useCount: number;
  lastUsedAt?: string | null;
  isRevoked: boolean;
  revokedAt?: string | null;
}

export interface CreatePairingTokenRequest {
  propertyId: string;
  buildingId: string;
}

export interface ClaimPairingTokenDto {
  accessToken: string;
  expiresAt: string;
  propertyId: string;
  buildingId: string;
}

export async function createPairingToken(data: CreatePairingTokenRequest): Promise<PairingTokenDto> {
  const res = await apiClient.post<ApiResponse<PairingTokenDto>>('/pairing-tokens', data);
  return res.data.data!;
}

// tokenOrShortCode accepts either the full raw token or the 6-char short code.
export async function claimPairingToken(tokenOrShortCode: string): Promise<ClaimPairingTokenDto> {
  const res = await apiClient.post<ApiResponse<ClaimPairingTokenDto>>(
    `/pairing-tokens/${encodeURIComponent(tokenOrShortCode)}/claim`,
  );
  return res.data.data!;
}

export async function getMyPairingTokens(): Promise<PairingTokenDto[]> {
  const res = await apiClient.get<ApiResponse<PairingTokenDto[]>>('/pairing-tokens/mine');
  return res.data.data ?? [];
}

export async function revokePairingToken(id: string): Promise<void> {
  await apiClient.delete(`/pairing-tokens/${id}`);
}
